import yup from './yup'
import { checkLeadingAndTrailingSpaces } from 'utils'

export const adminsFormSchema = yup.object().shape({
  fullName: yup
    .string()
    .label('Full Name')
    .trimmedRequired('Full Name is required field.')
    .matches(
      /^[\p{L}]+(?:[ '.-][\p{L}]+)*$/u,
      'Full Name must not contain numbers or special characters'
    ),
  email: yup.string().email().label('Email').required(),
  role: yup
    .string()
    .oneOf(['admin', 'owner'], 'Role must be admin or owner')
    .required('Role is required'),
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters')
    .test(
      'password-strength',
      'Password must contain at least one letter and one number',
      (value) => {
        return /^(?=.*[A-Za-z])(?=.*\d)/.test(value)
      }
    )
    .test('checkEditPass', 'Password cannot contain leading/trailing spaces', (value) => {
      if (!value || checkLeadingAndTrailingSpaces(value)) {
        return false
      }
      return true
    })
})

export const updatePasswordSchema = yup.object().shape({
  fullName: yup
    .string()
    .label('Full Name')
    .trimmedRequired('Full Name is required field.')
    .matches(
      /^[\p{L}]+(?:[ '.-][\p{L}]+)*$/u,
      'Full Name must not contain only numbers or special characters, and must not have consecutive spaces'
    ),
  newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .test(
      'password-strength',
      'Password must contain at least one letter and one number',
      (value) => {
        return /^(?=.*[A-Za-z])(?=.*\d)/.test(value)
      }
    )
    .test('checkEditPass', 'Password cannot contain leading/trailing spaces', (value) => {
      if (value && checkLeadingAndTrailingSpaces(value)) {
        return false
      }
      return true
    })
})

export const updateUserSchema = yup.object().shape({
  fullName: yup
    .string()
    .label('Full Name')
    .trimmedRequired('Full Name is required field.')
    .matches(
      /^[\p{L}]+(?:[ '.-][\p{L}]+)*$/u,
      'Full Name must not contain only numbers or special characters, and must not have consecutive spaces'
    ),
  role: yup
    .string()
    .oneOf(['admin', 'owner'], 'Role must be admin or owner')
    .required('Role is required'),
  newPassword: yup.string().test('optional-password', '', function (value) {
    if (!value) return true
    if (value.length < 8)
      return this.createError({ message: 'Password must be at least 8 characters' })
    if (!/^(?=.*[A-Za-z])(?=.*\d)/.test(value))
      return this.createError({
        message: 'Password must contain at least one letter and one number'
      })
    if (checkLeadingAndTrailingSpaces(value))
      return this.createError({ message: 'Password cannot contain leading/trailing spaces' })
    return true
  })
})

export const userLoginSchema = yup.object().shape({
  email: yup.string().email().label('Email').required(),
  password: yup.string().label('Password').required()
})

export const changePasswordSchema = yup.object({
  currentPassword: yup.string().required('Current password is required'),
  newPassword: yup
    .string()
    .required('New password is required')
    .min(8, 'Password must be at least 8 characters')
    .test(
      'password-strength',
      'Password must contain at least one letter and one number',
      (value) => {
        return /^(?=.*[A-Za-z])(?=.*\d)/.test(value)
      }
    ),
  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('newPassword'), null], 'Passwords must match')
})
